import { c as _c } from "react/compiler-runtime";
import React from "react";
interface WaveWinnersSmallEmptyProps {
  readonly isMultiDecision?: boolean | undefined;
  readonly message?: string | undefined;
  readonly title?: string | undefined;
}
export const WaveWinnersSmallEmpty: React.FC<WaveWinnersSmallEmptyProps> = t0 => {
  const $ = _c(7);
  const {
    isMultiDecision: t1,
    message,
    title: t2
  } = t0;
  const isMultiDecision = t1 === undefined ? false : t1;
  const title = t2 === undefined ? "No Winners Yet" : t2;
  const displayMessage = message ?? (isMultiDecision ? "No winners have been announced for this wave yet. Check back later!" : "This wave ended without any winning submissions");
  let t3;
  if ($[0] !== title) {
    t3 = <div className="tw-mt-4 tw-text-base tw-font-semibold tw-text-iron-300">{title}</div>;
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== displayMessage) {
    t4 = <p className="tw-mb-0 tw-mt-2 tw-text-center tw-text-sm tw-text-iron-400">{displayMessage}</p>;
    $[2] = displayMessage;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className="tw-p-3"><div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8">{t3}{t4}</div></div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};